function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#0E5B7C",
  fillRule: "evenodd",
  d: "M8.75 0c2.865 0 5.781 1.68 8.75 5.04a75.386 75.386 0 01-1.348 1.327c-.195.182-.67.586-1.425 1.211-.756.625-1.368 1.055-1.836 1.29-.47.234-1.088.481-1.856.741S9.505 10 8.75 10c-.938 0-1.797-.117-2.578-.352-.781-.234-1.563-.638-2.344-1.21-.781-.573-1.393-1.062-1.836-1.465C1.55 6.569.885 5.91 0 5c1.693-1.693 3.197-2.95 4.512-3.77C5.827.41 7.24 0 8.75 0zm-2.5 7.5c.703.703 1.536 1.055 2.5 1.055s1.79-.352 2.48-1.055 1.036-1.536 1.036-2.5-.345-1.797-1.036-2.5c-.69-.703-1.516-1.055-2.48-1.055S6.96 1.797 6.27 2.5 5.234 4.036 5.234 5s.339 1.797 1.016 2.5zm2.5-3.75c0 .365.117.664.352.898.234.235.533.352.898.352.26 0 .52-.091.781-.273V5a2.03 2.03 0 01-.586 1.465c-.39.403-.872.605-1.445.605a1.932 1.932 0 01-1.445-.605A2.03 2.03 0 016.719 5c0-.573.195-1.061.586-1.465.39-.403.872-.605 1.445-.605h.313c-.209.26-.313.534-.313.82z"
});

function SvgShow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 10
  }, props), _ref);
}

export default SvgShow;